import React, { useEffect, useState } from "react";
import { getLeaderBoard } from "../../utils/getLeaderBoard";
import countryCodeToFlag from "country-code-to-flag";

const LeaderboardPage = () => {
  const [topPlayers, setTopPlayers] = useState([]);
  useEffect(() => {
    (async () => {
      const { topPlayers } = await getLeaderBoard();
      setTopPlayers(topPlayers);
    })();
  }, []);
  return (
    <div className="bg-green-700 min-h-screen flex sm:items-center sm:justify-center ">
      <div className="bg-green-800 rounded-lg shadow-xl h-full w-full max-w-5xl overflow-hidden">
        <h1 className="text-3xl font-bold text-white text-center py-4 bg-green-900">
          Leaderboard
        </h1>
        <div
          className="overflow-auto"
          style={{ maxHeight: "calc(100vh - 70px)" }}
        >
          <table className="w-full">
            <thead className="bg-green-900 text-white">
              <tr>
                <th className="py-3 px-4 text-left w-1/6">Rank</th>
                <th className="py-3 px-4 text-left w-3/6">Name</th>
                <th className="py-3 px-4 text-left w-2/6">High Score</th>
              </tr>
            </thead>
            <tbody>
              {topPlayers.map((player, index) => (
                <tr
                  key={player.name}
                  className={`
                    ${
                      player.name === localStorage.getItem("userName")
                        ? "bg-yellow-500"
                        : index % 2 === 0
                        ? "bg-green-700"
                        : "bg-green-800"
                    }
                    hover:bg-green-600 transition-colors duration-150 ease-in-out
                  `}
                >
                  <td className="py-3 px-4 text-white">{player.rank}</td>
                  <td className="py-3 px-4 text-white flex items-center">
                    <span className="mr-2">{player.name}</span>
                    {/* {player?.country_code && (
                      <span>{countryCodeToFlag(player.country_code)}</span>
                    )} */}
                  </td>
                  <td className="py-3 px-4 text-white">{player.highscore}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardPage;
